var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsDarkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.788,
    height: 14,
    viewBox: "0 0 14.788 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161152",
    "data-name": "Group 161152",
    transform: "translate(-25.606 -622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings-2-svgrepo-com",
    transform: "translate(21.356 619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83223",
    "data-name": "Path 83223",
    d: "M18.474,7H11",
    transform: "translate(-0.187 -0.509)",
    fill: "none",
    stroke: "#2d68fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83224",
    "data-name": "Path 83224",
    d: "M11.709,17H5",
    transform: "translate(0.83 -3.204)",
    fill: "none",
    stroke: "#2d68fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(13 11)",
    fill: "none",
    stroke: "#2d68fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_268",
    "data-name": "Ellipse 268",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(5 4)",
    fill: "none",
    stroke: "#2d68fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140391",
    "data-name": "Rectangle 140391",
    width: 14,
    height: 14,
    transform: "translate(26 622)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsDarkIcon);
export default __webpack_public_path__ + "static/media/settings-dark-icon.957065db05c6c8fdd8eeae26289ca085.svg";
export { ForwardRef as ReactComponent };